"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDefaultFileProvider(fileProvidersViewState) {
    if (fileProvidersViewState.length !== 0) {
        return fileProvidersViewState[0];
    }
    return null;
}
exports.default = getDefaultFileProvider;
//# sourceMappingURL=getDefaultFileProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-filepicker-store/lib/actions/helpers/getDefaultFileProvider.js
// module id = 1803
// module chunks = 2 3 43 106 107